export default __webpack_public_path__ + "static/media/b2bLastName.2a4107a0.png";